import React from 'react'
import { Tooltip } from '../../common'

interface Props {
  poolBalanceThresholds?: number[]
}

export function GasRebatesTooltip({ poolBalanceThresholds }: Props) {
  return (
    <Tooltip>
      <p>Inactive</p>
    </Tooltip>
  )
}
